const CONTACTS = {
  // PHONE: "(058) 770-4142",
  PHONE: "2414-077 (850)",
  // PHONE: "4142-770 (580)",
  // PHONE: "770-4142 (058)"
};

export default CONTACTS;
